jQuery(document).ready(function($) {
    //$('#ptdf-posts').after($('#ptdf-load-more-posts')); // move button if needed
    function initAllSwipers() {
        $('#ptdf-posts .ptdf-swiper').each(function() {
            if (!this.swiper) { // Prevent double init
                new Swiper(this, {
                    slidesPerView: 1,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: $(this).find('.swiper-button-next')[0],
                        prevEl: $(this).find('.swiper-button-prev')[0],
                    },
                    pagination: {
                        el: $(this).find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    lazy: true,
                });
            }
        });
    }
    $(document).on('click', '#ptdf-load-more-posts', function(){
        let $btn = $(this);
        let offset = parseInt($btn.data('offset'), 10);
        let perPage = parseInt($btn.data('per-page'), 10);
        let userId = parseInt($btn.data('user-id'));

        $btn.prop('disabled', true).text('A carregar...');

        $.ajax({
            url: ptdfNetworkAjax.ajaxurl,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'ptdf_load_more_posts',
                offset: offset,
                per_page: perPage,
                userId: userId ? userId: null,
                nonce: ptdfNetworkAjax.nonce
            },
            success: function(resp){
                if(resp.success && resp.data.html){
                    $('#ptdf-posts').append(resp.data.html);
                    // Re-init Swiper (if used)
                    initAllSwipers()
                   // $('#ptdf-posts').after($btn);

                    // Update offset and state
                    $btn.data('offset', resp.data.new_offset);
                    if(!resp.data.has_more){
                        $btn.remove();
                    } else {
                        $btn.prop('disabled', false).text('Carregar Mais');
                    }

                    // Optionally re-init any JS plugins for new content here!
                } else {
                    $btn.remove();
                }
            },
            error: function(){
                $btn.prop('disabled', false).text('Load More');
            }
        });
    });
});